import { recentListingStatus, marketReportStatus } from '../_config';
export default {
    //  transfer  market report The parameters that need to be passed 
    marketReportParams(state, getters, rootState, rootGetters) {
        return {
            // ...rootGetters['search/searchParams'],
            ...state.searchParams,
            siteId: rootGetters.siteId
        };
    },
    //  call get listing  interface   The parameters that need to be passed 
    listingParams(state, getters, rootState, rootGetters) {
        return {
            // ...rootGetters['search/searchParams'],
            ...state.searchParams,
            siteId: rootGetters.siteId,
            listingStatus: state.currentListingStatus,
            page: state.pageNum,
            pageSize: state.pageSize
        };
    },
    // market snapshot Related status display 
    showMarketReportData(state, getters) {
        return (
            (state.fetchMarketReportStatus === marketReportStatus.loading ||
                state.fetchMarketReportStatus === marketReportStatus.loaded) &&
            !getters.showMarketNoData
        );
    },
    showMarketReportLoading(state) {
        return state.fetchMarketReportStatus === marketReportStatus.loading;
    },
    showMarketNoLocation(state) {
        return state.fetchMarketReportStatus === marketReportStatus.noLocation;
    },
    showMarketComing(state) {
        return state.fetchMarketReportStatus === marketReportStatus.coming;
    },
    showMarketNoData(state) {
        const { count, avgSoldPrice, avgOnSaleDays } = state.marketReport;
        return (
            state.fetchMarketReportStatus !== marketReportStatus.coming &&
            state.fetchMarketReportStatus !== marketReportStatus.noLocation &&
            count === 0 &&
            avgSoldPrice === 0 &&
            avgOnSaleDays === 0
        );
    },
    // recent listing Related status display 
    showRecentListingData(state, getters) {
        return (
            (state.fetchListingStatus === recentListingStatus.loading ||
                state.fetchListingStatus === recentListingStatus.loaded) &&
            !getters.showRecentListingNoData
        );
    },
    showRecentListingLoading(state) {
        return state.fetchListingStatus === recentListingStatus.loading;
    },
    showRecentListingNoLocation(state) {
        return state.fetchListingStatus === recentListingStatus.noLocation;
    },
    showRecentListingComing(state) {
        return state.fetchListingStatus === recentListingStatus.coming;
    },
    showRecentListingNoData(state) {
        return (
            state.fetchListingStatus !== recentListingStatus.coming &&
            state.fetchListingStatus !== recentListingStatus.noLocation &&
            state.listing.length === 0
        );
    },
    //  whether or not sold listing
    isSoldListing(state) {
        return state.currentListingStatus.toLowerCase() === 'sold';
    }
};
